export const columns = [
  { id: 1, column: 'contract_charge', class: 'w150', label: 'Freight', action: 'decrement', compareBy: false },
  { id: 2, column: 'transit_charge', class: 'w150', label: 'Transit Delay', action: 'no_check', compareBy: false },
  { id: 3, column: 'loading_charge', class: 'w150', label: 'Loading', action: 'decrement', compareBy: false },
  { id: 4, column: 'loading_detention_charge', class: 'w150', label: 'Loading Detention', action: 'detect_check', compareBy: false },
  { id: 5, column: 'unloading_detention_charge', class: 'w150', label: 'UnLoading Detention', action: 'detect_check', compareBy: false },
  { id: 6, column: 'unloading_charge', class: 'w150', label: 'Unloading', action: 'decrement', compareBy: false },
  { id: 7, column: 'arrival_charge', class: 'w150', label: 'Penalty', action: 'increment', compareBy: false },
  { id: 8, column: 'lr_charge', class: 'w100', label: 'LR', action: 'decrement', compareBy: false },
  { id: 9, column: 'additional_point_charges', class: 'w150', label: 'Additional Point', action: 'decrement', compareBy: false },
  { id: 10, column: 'oda_charges', class: 'w150', label: 'ODA', action: 'decrement', compareBy: false },
  { id: 11, column: 'extra_charges', class: 'w150', label: 'Miscellaneous charge', comments: true, action: 'no_check', compareBy: false },
  // { id: 11, column: 'no_tax', class: 'w150', readonly: true, label: 'GST', compareBy: true },
  { id: 12, column: 'shortage_charge', class: 'w150', label: 'Shortage', action: 'decrement', compareBy: false },
  { id: 13, column: 'damage_charge', class: 'w150', label: 'Damage', action: 'decrement', compareBy: false },
  { id: 14, column: 'leakage_charge', class: 'w150', label: 'Leakage', action: 'decrement', compareBy: false },
  { id: 15, column: 'carton_damage_charge', class: 'w150', label: 'Carton Damage', action: 'decrement', compareBy: false },
  { id: 16, column: 'wallet_penalty_charge', class: 'w150', label: 'SLA Delay', action: 'decrement', compareBy: false },
  // { id: 17, column: 'total_amount', class: 'w200', label: 'Total', action: 'decrement', compareBy: true },
];

export const invoiceTypes = [
  { id: 0, name: 'All invoices' },
  { id: 1, name: 'Clean Invoices' },
  { id: 2, name: 'Non Clean Invoices' },
];

export const invoiceHeading = [
  { id: 1, column: 'invoice_number', class: 'w150', label: 'Invoice Number' },
  { id: 2, column: 'created_at', class: 'w150', label: 'Invoice Created' },
  // { id: 3, column: 'indents_count', class: 'w150', label: 'No of Indents' },
  { id: 4, column: 'transporter', class: 'w200', label: 'Transporter' },
  { id: 5, column: 'transporter_refid', class: 'w150', label: 'Trans Ref Id' },
  { id: 6, column: 'invoice_number', class: 'w120', label: 'LR NUMBER' },
  { id: 7, column: 'invoice_amount', class: 'w150', label: 'INVOICE  AMOUNT' },
];

export const voucherHeading = [
  { id: 1, column: 'invoice_number', class: 'w120', label: 'Number' },
  { id: 2, column: 'invoice_number', class: 'w120', label: 'Created On' },
  { id: 4, column: 'invoice_number', class: 'w150', label: 'Invoices' },
  { id: 5, column: 'invoice_number', class: 'w160', label: 'Transporter' },
  { id: 6, column: 'transporter_refid', class: 'w150', label: 'Trans Ref Id' },
  { id: 7, column: 'transporter_amount', class: 'w150', label: 'REQUESTED' },
  { id: 8, column: 'amount', class: 'w150', label: 'VOUCHER AMOUNT' },
];
